import { mapState } from 'vuex';
import { Center, Row, Col } from '@styled/global';
import styled from 'vue-styled-components';
import { display } from 'styled-system';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   cursor: pointer;\n   liststyletype: none;\n   padding: 0;\n   marginright: 22px;\n   &:disabled: {\n      opacity: 1/4;\n   }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n   font-family: inherit;\n   -webkit-font-smoothing: antialiased;\n   display: flex;\n   flex-direction: row;\n   vertical-align: middle;\n   textalign: center;\n   textdecoration: none;\n   appearance: none;\n   font-size: 12px;\n   color: ", ";\n\n   & a {\n      font-weight: bold;\n      text-decoration: none;\n      outline: none;\n      margin-right: 22px;\n\n      &:hover {\n         text-decoration: underline;\n      }\n\n      &.router-link-exact-active {\n      }\n   }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n   margin: 4px 0 0 0;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n   color: ", ";\n   border: 0;\n   outline: 0;\n   margin: 0 8px 0 20px;\n   display: flex;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   width: 26px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   border: 0;\n   outline: 0;\n   display: flex;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   background: ", ";\n   width: 30px;\n   height: 30px;\n   border: 0;\n   outline: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   height: 17px;\n   background: transparent;\n   border: 0;\n   outline: 0;\n   font-size: 14px;\n   width: 188px;\n   margin: 4px 8px;\n\n   &::placeholder {\n      color: rgba(0, 0, 0, 0.55);\n      font-style: italic;\n      font-size: 13px;\n   }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   border: 1px solid #000;\n   border-color: ", ";\n   margin: auto 0;\n   display: flex;\n   align-items: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   transition: height 0.4s ease;\n   margin-left: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   transition: height 0.4s ease;\n   display: flex;\n   justify-content: center;\n   width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Section = styled("section", {})(_templateObject());
var LogoImage = styled("img", {})(_templateObject2());
var SearchContainer = styled("div", {})(_templateObject3(), function (props) {
  return props.theme.secondaryColor;
});
var SearchInput = styled("input", {})(_templateObject4());
var SearchButton = styled("div", {})(_templateObject5(), function (props) {
  return props.theme.secondaryColor;
});
var MenuButton = styled.div(_templateObject6());
var SearchIcon = styled.img(_templateObject7());
var MenuLabel = styled("span", {})(_templateObject8(), function (props) {
  return props.theme.secondaryColor;
});
var MenuArrow = styled("svg", {})(_templateObject9());
var NavBar = styled("ul", {})(_templateObject10(), function (props) {
  return props.theme.primaryColor;
});
var NavItem = styled("li", {
  display: {
    type: [String, Object, Array]
  }
})(_templateObject11(), display);

var script = {
  name: "page-header",
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      componentKey: 0
    };
  },
  methods: {
    forceRerender: function forceRerender() {
      this.componentKey += 1;
    },
    findMatchingLogo: function findMatchingLogo(breakpoint) {
      var match = this.copy.logos.find(function (item) {
        return item.breakpoints.indexOf(breakpoint) !== -1;
      });
      return match ? match : null;
    }
  },
  computed: _extends({}, mapState("viewport", ["breakpoint", "scroll"]), {}, mapState("locale", ["locale"]), {}, mapState("auth", ["user"])),
  watch: {
    $route: function $route(to, from) {
      // Change local state to force render of navigation links
      this.forceRerender();
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    // Determine component height based on viewport and if the user has started scrolling
    var heights = {
      xs: 35,
      sm: 35,
      md: 75,
      lg: 75,
      xl: 75
    };
    var searchDisplayLookup = {
      xs: "none",
      sm: "none",
      md: "flex",
      lg: "flex",
      xl: "flex"
    };
    var isMobile = this.breakpoint === "xs" || this.breakpoint === "sm";
    var isScrolled = this.scroll.y > 4;
    var targetHeight = isMobile || isScrolled ? heights["sm"] : heights[this.breakpoint];
    var logoHeight = isMobile || isScrolled ? 25 : heights[this.breakpoint] - 40;
    var logo = this.findMatchingLogo(isMobile || isScrolled ? "sm" : this.breakpoint);
    var sectionStyle = {
      height: targetHeight + "px"
    };
    var logoStyle = {
      height: logoHeight + "px"
    };
    var displaySearch = isMobile || isScrolled ? "none" : searchDisplayLookup[this.breakpoint];
    var currentPath = this.$router.history.current.path;
    var tabs = this.user === null ? null : this.copy.nav.map(function (link) {
      // Modify the URL if this is the toggle locale link
      var url = link.url;

      if (_this.user && link.id === "signIn") {
        return null;
      } else if (_this.user === null && link.id === "signOut") {
        return null;
      } else if (link.id === "locale") {
        url = _this.locale === "en" ? currentPath + "/es" : "" + currentPath.replace("/es", "");
      }

      return h(NavItem, {
        "key": link.id,
        "attrs": {
          "display": link.display
        }
      }, [h("RouterLink", {
        "attrs": {
          "to": url,
          "id": link.id,
          "exact": true
        }
      }, [link.label])]);
    });
    return h(Section, {
      "style": sectionStyle
    }, [h(Center, [h(Row, [h(Col, {
      "attrs": {
        "width": [3],
        "flexDirection": "row"
      }
    }, [h("RouterLink", {
      "attrs": {
        "to": "/"
      }
    }, [h(LogoImage, {
      "style": logoStyle,
      "attrs": {
        "src": logo.url,
        "alt": logo.alt
      }
    })])]), h(Col, {
      "attrs": {
        "width": [9],
        "flexDirection": "row",
        "justifyContent": "flex-end"
      },
      "style": {
        display: this.user ? "flex" : "none"
      }
    }, [h(NavBar, {
      "key": this.componentKey
    }, [tabs]), h(SearchContainer, {
      "style": {
        display: displaySearch
      }
    }, [h(SearchInput, {
      "attrs": {
        "placeholder": this.copy.search.placeholder
      }
    }), h(SearchButton, [h(SearchIcon, {
      "attrs": {
        "alt": "search",
        "src": this.copy.search.image.url
      }
    })])]), h(MenuButton, [h(MenuLabel, ["Menu"]), h(MenuArrow, {
      "attrs": {
        "focusable": "false",
        "id": "downArrow",
        "version": "1.1",
        "width": "20",
        "height": "10",
        "viewBox": "0 0 20 12"
      }
    }, [h("path", {
      "attrs": {
        "className": "down-arrow",
        "d": "M 2,2 10,10 18,2",
        "fill": "none",
        "stroke": "#dc1431",
        "strokeWidth": "3",
        "strokeLinejoin": "miter",
        "strokeLinecap": "butt"
      }
    })])])])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
